/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "divider-e69fa021--sprite",
  "use": "divider-e69fa021--sprite-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 80\" id=\"divider-e69fa021--sprite\">\n  <g id=\"divider-e69fa021--sprite_Group_79589\" data-name=\"Group 79589\" transform=\"translate(-278.763 -131.687)\">\n    <path id=\"divider-e69fa021--sprite_Path_59670\" data-name=\"Path 59670\" d=\"M258.529,2.375a40,40,0,1,1-40,40,40,40,0,0,1,40-40\" transform=\"translate(60.234 129.312)\" fill=\"#fcf8d0\" />\n    <path id=\"divider-e69fa021--sprite_Path_59671\" data-name=\"Path 59671\" d=\"M275.077,43.983h-2.963v.758h-3.7c-1.74-3.6-3.729-7.677-5.333-10.956a7.185,7.185,0,0,0-2.536-12.96V19.579a1.511,1.511,0,1,0-3.023,0v1.247a7.18,7.18,0,0,0-2.533,12.959c-1.6,3.279-3.593,7.356-5.333,10.956h-4.3v-.758H243.6v3.023h1.754v-.758h3.578c-1.664,3.458-2.985,6.248-3.3,7.039a2.837,2.837,0,0,0,1.2,3.243l1.1,5.735L250.95,53.8l-.006-.008v0l2.693-7.539h10.792l2.691,7.547,0,0,3.023,8.468,1.1-5.733,0,0a2.848,2.848,0,0,0,1.2-3.243c-.312-.791-1.633-3.581-3.3-7.039h2.973v.758h2.963a1.511,1.511,0,1,0,0-3.023m-20.2-16.138a4.156,4.156,0,0,1,8.312,0,4.181,4.181,0,0,1-3.849,4.145,2.057,2.057,0,0,1-.3.015,2,2,0,0,1-.3-.015,4.165,4.165,0,0,1-3.857-4.145m-.7,16.9,3.512-9.834a7.173,7.173,0,0,0,2.7,0l3.507,9.834Z\" transform=\"translate(60.234 129.312)\" fill=\"#f3b65a\" />\n  </g>\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
